module.exports = __webpack_public_path__ + "static/Solideo-51b237bcf5a881e3d5aaa2d5c6488f50.jpg";